import Ingredient from './ingredient';
import MealItemAssignment from './meal-item-assignment';
import Measure from './measure';
import {
  BaseEntity,
  JsonApiProperty,
  JsonApiRelationship,
  JsonApiResource,
} from '../jsonapi-provider';

@JsonApiResource({
  type: 'meal-item-assignment-ingredient',
})
export default class MealItemAssignmentIngredient extends BaseEntity {
  @JsonApiProperty({ resolver: Number }) public sortOrder: number = 127;
  @JsonApiProperty({ resolver: Number }) units: number = 1.0;

  @JsonApiRelationship('ingredient') ingredient: Ingredient;
  @JsonApiRelationship('meal-item-assignment') mealItemAssignment: MealItemAssignment;
  @JsonApiRelationship('measure') measure: Measure;

  @JsonApiProperty({ resolver: (value) => (value ? Number(value) : value), readOnly: true })
  originalUnits: number | undefined;

  @JsonApiProperty({ type: 'object', readOnly: true })
  public get isPrimary(): boolean {
    return this.sortOrder === 0;
  }

  @JsonApiProperty({ type: 'object', readOnly: true })
  public get isNew(): boolean {
    return this.originalUnits === 0 && this.units > 0;
  }

  @JsonApiProperty({ type: 'object', readOnly: true })
  public get isModified(): boolean {
    return this.originalUnits !== 0 && this.originalUnits !== this.units;
  }

  @JsonApiProperty({ type: 'object', readOnly: true })
  public get isOriginal(): boolean {
    return this.originalUnits !== 0 && this.originalUnits === this.units;
  }

  constructor(
    id?: MealItemAssignmentIngredient['id'],
    ingredient: MealItemAssignmentIngredient['ingredient'] = new Ingredient(),
    units: MealItemAssignmentIngredient['units'] = 1.0,
    measure: MealItemAssignmentIngredient['measure'] = new Measure('1'),
    mealItemAssignment: MealItemAssignmentIngredient['mealItemAssignment'] = new MealItemAssignment(),
    originalUnits: number = 0,
    sortOrder: MealItemAssignmentIngredient['sortOrder'] = 127
  ) {
    super();
    this.id = id;
    this.ingredient = ingredient;
    this.units = units;
    this.mealItemAssignment = mealItemAssignment;
    this.measure = measure;
    this.originalUnits = originalUnits;
    this.sortOrder = sortOrder;
  }
}
